import { useCallback } from "react";
import { EndPoints } from "src/config";
import { useFetcher } from "src/hooks/useFetcher"
import { TrackingColiPublicDataFetchPayload, TrackingColiPublicDataModel } from "../tracking-colis-public.types";

export const useTrackingColisPublic = () => {
    const {isLoading, error, fetcher,data} = useFetcher<TrackingColiPublicDataModel | null>(null);

    const fetchData = useCallback(({tracking, code}:TrackingColiPublicDataFetchPayload)=> {
        fetcher(EndPoints.getColiTrackingPublic, {
            requiredToken:false,
            body:{
                tracking,
                code,
            }
        })
    },[fetcher]);

    return {
        isLoading,
        error,
        data,
        fetchData
    }
}